// 导入封装的方法
import {
  post
} from '../http'

const remoteNegotiation = {
  remoteconsultation: {
    list (params) {
      return post('/remoteconsultation/publicList', params)
    },
    info (params) {
      return post('/remoteconsultation/web/info/' + params)
    }
  },
  comment: {
    list (params) {
      return post('/comment/listPublic', params)
    },
    save (params) {
      return post('/comment/savePublic', params)
    }
  }
}
export default remoteNegotiation
